import { Component, OnInit } from "@angular/core";
import { BroadcastService, MsalService } from "@azure/msal-angular";
import { Logger, CryptoUtils } from "msal";
import { HttpClient } from "@angular/common/http";
const GRAPH_ENDPOINT = "https://graph.microsoft.com/v1.0/me";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  isIframe = false;
  public loggedIn = false;

  public profile;

  constructor(
    private broadcastService: BroadcastService,
    private authService: MsalService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkoutAccount();

    this.broadcastService.subscribe("msal:loginSuccess", () => {
      this.checkoutAccount();
      this.http
        .get(GRAPH_ENDPOINT)
        .toPromise()
        .then((profile) => {
          this.profile = profile;
        });
    });

    this.authService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error("Redirect Error: ", authError.errorMessage);
        return;
      }

      console.log("Redirect Success: ", response.accessToken);
    });

    /*this.authService.setLogger(
      new Logger(
        (logLevel, message, piiEnabled) => {
          console.log("MSAL Logging: ", message);
        },
        {
          correlationId: CryptoUtils.createNewGuid(),
          piiLoggingEnabled: false
        }
      )
    );*/
  }

  checkoutAccount() {
    this.loggedIn = !!this.authService.getAccount();
  }

  login() {
    const isIE =
      window.navigator.userAgent.indexOf("MSIE ") > -1 ||
      window.navigator.userAgent.indexOf("Trident/") > -1;

    if (isIE) {
      this.authService.loginRedirect();
    } else {
      this.authService.loginPopup();
    }
  }

  logout() {
    this.authService.logout();
  }

  isSignedIn(): boolean {
    return this.loggedIn;
  }
}
